import { useStores } from '../stores';

/**
 * This hook used the Context API earlier,
 * it was left until the config from RootStore is used everywhere.
 */
export default function useConfig() {
  const { config } = useStores();

  return config;
}
